<template>
  <div class="row">
    <div class="col">
      <input type="date" v-model="date" @change="updateDate" class="form-control"/>
    </div>
    <div class="col">
      <input type="time" v-model="time" @change="updateTime" class="form-control"/>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      date: '',
      time: '',
    }
  },
  mounted() {
    console.log('mounted',this.value);
    if (this.value && this.value.indexOf('T') > 0) {
      var split = this.value.split('T');
      console.log(split);
      this.date = split[0];
      this.time = split[1];
    }
  },
  methods: {
    updateTime() {
      console.log('update time: ',this.time);
      this.$emit('update',this.date + 'T' + this.time);
    },
    updateDate() {
      console.log('update date: ',this.date);
      this.$emit('update',this.date + 'T' + this.time);
    }
  }
}
</script>
